module.exports = __webpack_public_path__ + "img/21.ea29b590.jpg";